<template>  
    <section class="confirm-submit">
        <!-- 支付弹框 -->
		<pay-modal :payPrice="detailList.order_total_price" v-if="isShowModal" :showClose="true"
            @close-modal="onCloseModalClick" @payClick='payClick' @goToCharge="goToCharge">
        </pay-modal>
		 
		<!-- 钱包余额不足弹框 -->
		<confirm-modal v-if="noEnough" :isEnough="true" :firmTitle="firmTitle" :firmLeft="firmLeft" :firmRight="firmRight"
            @leftClick="onCloseModalClick" @rightClick="goToCharge">
        </confirm-modal>
		
		<qr-code-url v-if="qrcodeUrl" :qrcodeUrl="qrcodeUrl" tips="支付" :chargeMoney="detailList.order_total_price" @deletePay="onCloseModalClick"></qr-code-url>

        <ul class="order-content">
            <li class="order-detail">
                <div class="link-wrap">
					<img src="@/assets/images/order-manage/ic_home_line_7.png" alt="" class="pt-img">
                    <span class="service-left">服务信息</span>
                </div>
				
				<div class="customer-info">
				    <span class="info-style">服务项目</span>
				    <span class="info-style">{{detailList.server_info.server_name}}</span>
				</div>
				
				<div class="customer-info discount-wrap" v-if="detailList.is_member==2">
				    <span class="info-style">会员优惠</span>
					<div>
						<span class="info-style">已优惠</span>
						<span class="discount">{{detailList.order_member_price}}</span><span class="dan-wei">元</span>
					</div>
				</div>
				
                <div class="customer-info pm">
                    <span class="info-style pay-title">实付金额</span>
					<span class="info-style pay-money">¥{{detailList.order_total_price}}</span>
                </div>
            </li>
            
            <li class="order-detail p-b">
                <div class="link-wrap">
					<img src="@/assets/images/order-manage/ic_home_line_8.png" alt="" class="pt-img">
                    <span class="link">联系信息</span>
                </div>
				<div class="customer-info" v-for='(item,index) in detailList.question_url' :key='index' :class='{"no-h":!item}'>
					<span v-if="item" class="info-style" v-text='detailList.server_type==1?"商品链接":"商家网址"'></span>
					<span v-if="item" class="info-style limit-wth copy-s">{{item}}</span>
					<img src="@/assets/images/order-manage/ic_copy.png" alt="" class="copy-logo" @click="utils.copyText(item)"/>
				</div>
				<div v-if="detailList.server_type==1">
					<div class="customer-info">
					    <span class="info-style">卖家旺旺</span>
					    <span class="info-style limit-wth">{{detailList.merchant_wangwang}}</span>
					</div>
					<div class="customer-info">
					    <span class="info-style">买家旺旺</span>
					    <span class="info-style limit-wth">{{detailList.consumer_wangwang}}</span>
					</div>
				</div>
				<div v-else>
					<div class="customer-info">
					    <span class="info-style">顾客手机</span>
					    <span class="info-style limit-wth">{{detailList.consumer_mobile}}</span>
					</div>
					<div class="customer-info">
					    <span class="info-style">顾客姓名</span>
					    <span class="info-style limit-wth">{{detailList.consumer_name}}</span>
					</div>
				</div>
                
            </li>
			
			<li class="order-detail">
			    <div class="link-wrap">
					<img src="@/assets/images/order-manage/ic_home_line_5.png" alt="" class="pt-img">
			        <span class="link">截图信息</span>
			    </div>
			    <div class="img-list">
			        <img v-for="(item,index) in order_image" :key="index" :src="item" alt="" @click="handleImgsClick(order_image,index)" class="img-size" />
			    </div>
			</li>
            
            <li class="order-detail" v-if="detailList.order_details">
                <div class="link-wrap">
					<img src="@/assets/images/order-manage/ic_home_line_9.png" alt="" class="pt-img">
                    <span class="link">情况备注</span>
                </div>
                <!-- <span class="un-connection">{{detailList.order_details_tag}}</span> -->
                <p class="describe">{{detailList.order_details}}</p>
            </li>
			
			<li class="order-detail p-b" v-if="detailList.after_sale_name || detailList.other_sale_massage">
			    <div class="link-wrap">
					<img src="@/assets/images/order-manage/ic_home_line_4.png" alt="" class="pt-img">
			        <span class="link">售后特权</span>
			    </div>
			    
			    <div class="customer-info" v-if="detailList.after_sale_type==2">
			        <span class="info-style">最大允许补偿金额</span>
			        <span class="info-style">¥{{detailList.compensation_price}}</span>
			    </div>
				<div class="customer-info" v-else-if="detailList.after_sale_type==4">{{detailList.other_sale_massage}}</div>
				
				<div class="customer-info f-s" v-else>{{detailList.after_sale_name}}</div>
			</li>
            
            <li class="order-detail">
                <div class="link-wrap">
					<img src="../../assets/images/order-manage/ic_home_line_6.png" alt="" class="pt-img"/>
                    <span class="link">订单协议</span>
                </div>
                
                <div class="agree-text">
<!--                   <p>1、处理期间，请拉黑或不与消费者联系、不对评价回复或解释（已回复的不影响处理）；</p>
                   <p>2、处理周期为五天，撤单应在五天后，期限内无故撤单须扣除订单金额50%违约金 ；</p>
                   <p>3、五天处理期限内，不自行或交由他人处理，期限内解决的订单，都代表任务完成，应当收取费用 。</p> -->
                  <p>1，订单处理期间，为避免双方同时跟进，口吻不一，产生不必要矛盾，延误订单，下单后请不与顾客联系；</p>
                  <p>2，订单处理期间，为提高处理效率，打消处理人员顾虑，订单处理期间成功订单都认定为处理人员功劳，请商家勿自行或交由他人处理；</p>
                  <p>
                    3，订单周期为5天，据单子难易，时效有长短，确保订单高效、有序处理，处理期间中途撤单，为违约，须承担50% 违约责任。
                  </p>
                </div>
            </li>
        </ul>
        
        <submit-pay @submitClick="confirmClick" :money="detailList.order_total_price" :step="step">
			<div class="back" @click="$router.go(-1)">返回</div>
		</submit-pay>
    </section>
</template>

<script>
	import CommonModal from '@/components/CommonModal'
    import CommonHeader from '@/components/CommonHeader'
    import PayModal from '@/components/PayModal'
    import ConfirmModal from '@/components/ConfirmModal'
	import QrCodeUrl from '@/components/QrCodeUrl'
	import {getOrderDetail,getOrderPay} from '@/api/order'
	import {getUserInfo} from '@/api/common'
	import utils from '@/assets/jslibs/utils'
    import submitPay from '@/components/submitPay';
  import wx from "weixin-js-sdk";
    export default {
        name: 'confirm-order',
        data(){
            return{
				utils,
				imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				order_uuid:this.$route.query.order_uuid,
                firmTitle:"钱包余额不足 该充值啦",
                firmLeft:"返回",
                firmRight:"充值",
				step:"确认",
				noEnough:false,  //余额不足弹框
                imgFlag:false,
				isShowModal:false,
				detailList:{
					server_info:{}
				},
				qrcodeUrl : '',
				timer:null,
				isMobile : utils.isMobile(),
                payStyle:1,                //选择支付的方式
                clickPay:true,			//判断是否可以点击支付，防止重复点击
                addClickPay:true,
				order_image:[]			//用于页面展示，已经拼上域名，传给后台的不加域名
            }
        },
        components: {
			CommonModal,
            CommonHeader,
            PayModal,
            ConfirmModal,
            submitPay,
			QrCodeUrl
        },
		
		beforeCreate(){
			sessionStorage.setItem("roleType","customer")
		},
       
        created() {
            window.scrollTo(0,0);
			this.getOrderDetail();
        },
        
        mounted(){
           document.title = "订单详情";
			window.addEventListener('touchmove', (event)=>{ 
				if(this.isShowModal || this.noEnough){
					event.preventDefault(); 
				}
			});
			
			window.addEventListener('pageshow',()=>{
			    if(sessionStorage.getItem("havePay") && sessionStorage.getItem("payId")) {
			        this.order_uuid = sessionStorage.getItem("payId");      //取成功支付之后的订单号
			        this.getPayStatus();
                    sessionStorage.removeItem("havePay");
                    sessionStorage.removeItem("payId");
			    }
			})
        },
        
        methods: {
			//获取订单详情
			async getOrderDetail(){
				const { data, status } = await getOrderDetail(this.order_uuid);
				if (status == 200){ 
					this.detailList = data;
					this.detailList.after_sale_name = utils.typeToName(this.detailList.after_sale_type);
					this.detailList.question_url = this.detailList.question_url.split(",");
					this.order_image = this.detailList.order_images.map((item,index)=>{
						return item
					})
					if(this.order_image && this.order_image.length){
					    this.order_image.forEach((item,index)=>{
					       this.order_image[index] = this.imgUrl + this.order_image[index];
					    })
					}
				}
			},

            navigateTo(path){
                this.$router.push(path)
            },
            
			// 确认下单
			confirmClick(){
				this.isShowModal = true;
			},
			
			// 确认支付
			async payClick(payStyle){
				this.payStyle = payStyle;
                if(!this.clickPay) {
                	window.toast("请勿重复点击","txt");
                	return;
                }
                this.clickPay = false;
                setTimeout(()=>{
                    this.clickPay = true;
                },3000)
				let obj ={type:this.payStyle,order_uuid:this.detailList.uuid};
        let web_obj = {type:this.payStyle,order_uuid:this.detailList.uuid};
				if(this.isMobile==1){
					obj.order_tag = 1;
          web_obj.order_tag = 1;
				}else if(this.isMobile==2){
					obj.order_tag = 2
          web_obj.order_tag = 2;
				}else if(this.isMobile==3){
					obj.order_tag = 3;
          web_obj.order_tag = 3;
				}
        //判断一下是不是在小程序中
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            // 小程序环境下逻辑
            console.log("小程序环境,需要调用小程序支付");
            //obj.order_tag = 3;
            web_obj.order_tag = 4;
            obj.wx_type   = 'minApp' //小程序
          }
        });

				const { data, status } = await getOrderPay(obj);
                this.isShowModal = false;
				if(status==200){
					if(this.payStyle=="2"){//钱包支付
						this.$router.push({path:"./pay-success",query: {order_uuid:data.order_uuid,totalPrice:this.detailList.order_total_price}});
					}
					else{//微信支付
						if(web_obj.order_tag == 2){//扫码支付
							this.isShowModal = false;
							this.order_tag = "2";
							this.qrcodeUrl = data.code_url;							
						} else if(web_obj.order_tag == 1){
							this.order_tag = "1";
                            sessionStorage.setItem("havePay","havePay");
                            sessionStorage.setItem("payId",data.order_uuid);
							var UserAgent = navigator.userAgent.toLowerCase();
							if(/safari/.test(UserAgent) && !/chrome/.test(UserAgent)){
								var backUrl = "https://server-order.yongxintao.com/#/pay-success?order_uuid="+data.order_uuid+"&totalPrice="+this.detailList.order_total_price;
								sessionStorage.setItem("backUrl",backUrl);
							    location.href = data.mweb_url;
							}else{
							    location.href = data.mweb_url;
							}
						}else if(web_obj.order_tag == 3){//微信公众号支付
                            let timeStamp = String(data.timeStamp);
                            this.order_tag = "3"
                            this.pay("wxf3c9d00e530fedd8",timeStamp,data.nonceStr,data.package,data.signType,data.paySign);
            }else if (web_obj.order_tag == 4){
						  //小程序支付
              //this.AWechatJsPay();
              data.timeStamp = String(data.timeStamp);

              const payParamsStr = encodeURIComponent(JSON.stringify(data));
              const url=`../wxpay/wxpay?payParamsStr=${payParamsStr}`;
              wx.miniProgram.navigateTo({url:url});
              console.log('跳到小程序支付页面中去')
            }
					}
					this.order_uuid = data.order_uuid;
					this.getPayStatus()

				}else{
					if(data.error.message == "余额不足" && this.payStyle=="2"){
						this.noEnough = true;
					}
				}
			},
            
            // 调微信支付
            pay(appId,timeStamp,nonceStr,packages,signType,paySign){  
            	let self = this;
                if (typeof WeixinJSBridge == "undefined"){  
                   if( document.addEventListener ){  
                       document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);  
                   }else if (document.attachEvent){  
                       document.attachEvent('WeixinJSBridgeReady', onBridgeReady);   
                       document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);  
                   }  
                }else{  
                   self.onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign);  
                }   
            },  
            
            //唤醒微信支付
            onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign){
                let self = this;
            	WeixinJSBridge.invoke(
            		'getBrandWCPayRequest',
            		{
            			"appId":"wxf3c9d00e530fedd8",     //公众号名称，由商户传入     
            			"timeStamp":timeStamp,         //时间戳，自1970年以来的秒数     
            			"nonceStr":nonceStr, //随机串     
            			"package":packages,     
            			"signType":signType,         //微信签名方式：     
            			"paySign":paySign //微信签名 
            		},
            		
            		function(res){
            			if(res.err_msg == "get_brand_wcpay_request:ok"){// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            				self.$router.push({path:"./pay-success",query: {order_uuid:self.order_uuid,totalPrice:this.detailList.order_total_price}});
            			}else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                            window.toast("支付失败","txt");
            			}else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                            window.toast("支付失败","txt");
            			}
            		}
            	)
            },
			
			// 轮询支付状态
			async getPayStatus(){
				clearTimeout(this.timer);
				const { data, status } = await getOrderDetail(this.order_uuid);
				if( status == 200 && data.is_pay == 2){
					clearTimeout(this.timer);
					this.qrcodeUrl = false;
					this.isShowModal = false;
					this.$router.push({path:"./pay-success",query: {order_uuid:this.order_uuid,totalPrice:this.detailList.order_total_price}});
				}else{
					clearTimeout(this.timer);
					this.timer = setTimeout(()=>{
						this.getPayStatus()
					},2000)
				}
			},
			
			// 去充值
			goToCharge(){
				this.isShowModal = false
				this.noEnough = false;
				this.$router.push({path:"./recharge",query: {url:location.href}})
			},


			// 关闭弹框
			onCloseModalClick(){
				this.isShowModal =false;   //关闭弹框
				this.noEnough = false;     //取消充值
				this.qrcodeUrl = false;
				clearTimeout(this.timer);
			},
			
			handleImgsClick(item,index) {
				this.initialIndex = index
				const params = {
					$props: {
						imgs: item,
						initialIndex: 'initialIndex', // 响应式数据的key名
						loop: false
					},
					$events: {
						change: (i) => {
							// 必须更新 initialIndex
							this.initialIndex = i
						}
					}
				}
				this.$createImagePreview({ ...params }).show()
			}
        },
    }
</script>
<style>
	.confirm-submit .submit-pay .submit{width: 115px;}
</style>

<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5;padding: 10px 10px 0 10px;}
    .service-left{color:rgba(51,51,51,1);text-align: justify;display: inline-block;vertical-align: top;.f-s(15);font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;}
	.order-content{padding-bottom: 72px}
	.order-detail{margin-bottom: 10px;background: #fff}
	.order-wrap{font-size: 0;height: 1.38666667rem;padding:0 15px;line-height: 1.38666667rem;display: -webkit-box;display: -ms-flexbox;display: -webkit-flex;display: flex;border-bottom: 0.026667rem solid #EEEEEE;align-items: center;font-weight: 500}
	.un-boder{border: none;justify-content: space-between;}
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.order-left{font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(102,102,102,1);}
    .link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 15px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.link{display: inline-block;vertical-align: middle;color:rgba(20,20,20,1);font-size: 15px;font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;color: rgba(51,51,51,1);}
	.show-link{width: 335px;padding: 10px;margin: 0 auto;color:rgba(74,74,74,1);font-size: 14px;box-sizing: content-box}
    .customer-info{padding: 10px 15px 2px 15px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap}
    .info-style{color:rgba(74,74,74,1);font-size: 14px}
    .p-b{padding-bottom:8px}
    .f-s{color: #4a4a4a;font-size: 0.373333rem;}
    .un-connection{display: inline-block;color:rgba(65,132,244,1);font-size: 13;padding:5px 17px;background:rgba(239,247,255,1);border-radius:4px;margin: 11px 0 9px 10px}
    .describe{color:rgba(74,74,74,1);font-size: 14px;padding: 8px 10px 8px 10px;}
    .img-list{display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;padding:15px 17.5px}
    .img-size{width: 95px;height:95px;margin-right: 16px;padding-bottom: 7.5px}
	.img-list .img-size:nth-child(3n){margin-right: 0}
    .agree-text{padding: 10px 14px 10px 14px}
    .agree-text p{font-size:14px;line-height: 25px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(102,102,102,1);letter-spacing:1px;}
	
	.pm{padding-bottom: 18px;}
	.pay-title{font-size: 14px;font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;color: rgba(74,74,74,1)}
	.pay-money{font-size: 18px;font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;color: rgba(20,20,20,1);}
	.back{width:115px;height:60px;line-height: 60px;text-align: center;background:rgba(193,193,193,1);font-size:18px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(255,255,255,1);}
	.no-h{padding: 0;}
	.limit-wth{margin-right: 0.213333rem; white-space: nowrap;text-overflow: ellipsis;overflow: hidden;flex: 1; margin-right: 0.213333rem;margin-left: 0.64rem;text-align: right;}
	.discount-wrap{border-bottom: 0.026667rem solid #EEEEEE;margin: 0.266667rem 0.4rem 0.053333rem 0.4rem;padding: 0;padding-bottom: 0.32rem;}
	.discount{color:rgba(255,134,48,1);font-size: 14px;padding-left: 4px;}
	.dan-wei{color: #4a4a4a;font-size: 14px;}
	.copy-logo{width: 12px;height: 12px}
	.copy-s{margin-left: 0.64rem;flex: 1;text-align: right;margin-right: 0.213333rem;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}
</style>
